import React from 'react'
import { SvgIcon } from '@material-ui/core'

function ClearIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Line 5 (Stroke)'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.53033 18.605C5.23744 18.3121 5.23744 17.8373 5.53033 17.5444L17.5445 5.5302C17.8374 5.23731 18.3123 5.23731 18.6052 5.5302C18.8981 5.8231 18.8981 6.29797 18.6052 6.59086L6.59099 18.605C6.2981 18.8979 5.82322 18.8979 5.53033 18.605Z'
        stroke-width='0.5'
        stroke-linecap='round'
      />
      <path
        id='Line 5 (Stroke)_2'
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M5.53033 5.76606C5.23744 6.05895 5.23744 6.53382 5.53033 6.82672L17.5445 18.8409C17.8374 19.1338 18.3123 19.1338 18.6052 18.8409C18.8981 18.548 18.8981 18.0731 18.6052 17.7802L6.59099 5.76606C6.2981 5.47316 5.82322 5.47316 5.53033 5.76606Z'
        stroke-width='0.5'
        stroke-linecap='round'
      />
    </SvgIcon>
  )
}

export default ClearIcon
